import { render } from "./AdminSelector.vue?vue&type=template&id=23e1f010"
import script from "./AdminSelector.vue?vue&type=script&lang=js"
export * from "./AdminSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__